import { baseRouteMaker, routes } from "../../../constants/routeConsts";
import i18n from "../../../i18n/i18n";

export const useCustomerDBMenuUtils = () => {
  const tempMenuGroup = [];

  /* menuItemCustomerInfo */
  const menuItemCustomerInfo = {
    id: "serviceProvidercustomerInfo",
    title: i18n.t("Modules.customer.customerInfo"),
    url: baseRouteMaker(routes.SERVICE_PROVIDER_CUSTOMER_INFO),
  };
  tempMenuGroup.push(menuItemCustomerInfo);
  /* menuItemCustomerInfo */

  return tempMenuGroup;
};
